const getCrypto = () => {
  if (typeof window !== 'undefined' && window.crypto) return window.crypto;
  return null;
};

const bytesToHex = (bytes) =>
  Array.from(bytes)
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');

export const randomToken = (length = 32) => {
  const cryptoObj = getCrypto();
  if (cryptoObj?.getRandomValues) {
    const bytes = new Uint8Array(length);
    cryptoObj.getRandomValues(bytes);
    return bytesToHex(bytes).slice(0, length * 2);
  }
  return Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2);
};

export const hashString = async (value) => {
  const cryptoObj = getCrypto();
  if (cryptoObj?.subtle) {
    const encoder = new TextEncoder();
    const data = encoder.encode(value);
    const hashBuffer = await cryptoObj.subtle.digest('SHA-256', data);
    return bytesToHex(new Uint8Array(hashBuffer));
  }
  let hash = 0;
  for (let i = 0; i < value.length; i += 1) {
    hash = (hash << 5) - hash + value.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash).toString(16);
};

export const hashPassword = async (password) => {
  const salt = randomToken(12);
  const hash = await hashString(`${salt}:${password}`);
  return `${salt}$${hash}`;
};

export const verifyPassword = async (password, stored) => {
  if (!stored) return false;
  const [salt, hash] = stored.split('$');
  if (!salt || !hash) return false;
  const computed = await hashString(`${salt}:${password}`);
  return computed === hash;
};

export const buildTokenHash = async (token) => hashString(token);
